import React, { useEffect, useState } from "react";
import { getIndividualPricing } from "../../api";
import { track } from "../../utils/analytics";
import { getOnboarding } from "../../utils/attribution";
import { MOTIVATION_LABELS } from "./onboardingContent";

/**
 * OnboardingCta — the funnel's final screen: echo the visitor's plan back to
 * them, then hand off to the existing signup wizard (/?signup=1). Pricing and
 * trial length come from the API — both are admin-configurable, never
 * hardcoded in copy.
 */
export default function OnboardingCta({ motivation, dailyMinutes }) {
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    getIndividualPricing().then(setPricing).catch(() => {});
  }, []);

  const goal = MOTIVATION_LABELS[motivation];
  const trialDays = pricing?.trial_days || 7;
  const monthly = pricing ? (pricing.monthly_price_cents / 100).toFixed(2).replace(/\.00$/, "") : null;

  const startTrial = () => {
    const { utm_source: source } = getOnboarding();
    track("onboarding-cta-click", { source: source || "direct", motivation: motivation || "none" });
    // Full navigation (not SPA navigate): App's URL-param handling runs on
    // mount, and this matches the proven IrabUpsell hand-off.
    window.location.assign("/?signup=1");
  };

  return (
    <div className="w-full text-center">
      <p dir="rtl" lang="ar" className="font-amiri text-3xl text-dt-gold-bright mb-4 select-none">
        بِسْمِ اللَّهِ نَبْدَأ
      </p>
      <h2 className="text-xl sm:text-2xl font-semibold text-dt-parchment mb-2">
        Your plan is ready
      </h2>
      <p className="text-sm text-dt-parchment-dim mb-6">
        {goal ? (
          <>
            {goal.charAt(0).toUpperCase() + goal.slice(1)}
            {dailyMinutes ? `, ${dailyMinutes} minutes a day` : ""} — however long
            it takes. Every day counts.
          </>
        ) : (
          "Daily Arabic, built around the language of the Quran."
        )}
      </p>

      <div className="surface rounded-xl px-4 py-4 mb-6 text-left">
        <ul className="text-sm text-dt-parchment space-y-2">
          <li>✓ Full access for {trialDays} days — free</li>
          <li>✓ No card needed to start</li>
          <li>✓ Keep going{monthly ? ` for $${monthly}/month` : ""}, or walk away — your call</li>
        </ul>
      </div>

      <button
        type="button"
        onClick={startTrial}
        className="w-full px-4 py-3.5 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-[15px] font-semibold transition-[filter]"
      >
        Start my {trialDays}-day free trial
      </button>
      <a href="/" className="inline-block mt-4 text-sm text-dt-parchment-dim hover:text-dt-parchment">
        I already have an account
      </a>
    </div>
  );
}
